module.exports = __webpack_public_path__ + "img/nodata.073295ed.png";